import { isValidDate } from '@/shared/lib';

export interface ResolvedUserDismissalState {
  dismissalDate: Date | null;
  status: string;
}

function getDateOnlyTime(date: Date): number {
  const normalizedDate = new Date(date);
  normalizedDate.setHours(0, 0, 0, 0);
  return normalizedDate.getTime();
}

export function isDateAfter(leftDate: Date | null, rightDate: Date | null): boolean {
  if (!isValidDate(leftDate) || !isValidDate(rightDate)) return false;
  return getDateOnlyTime(leftDate) > getDateOnlyTime(rightDate);
}

export function isDateBefore(leftDate: Date | null, rightDate: Date | null): boolean {
  if (!isValidDate(leftDate) || !isValidDate(rightDate)) return false;
  return getDateOnlyTime(leftDate) < getDateOnlyTime(rightDate);
}

export function isDismissalDateBeforeAdmission(
  admissionDate: Date | null,
  dismissalDate: Date | null
): boolean {
  return isDateBefore(dismissalDate, admissionDate);
}

export function getValidDismissalDate(
  admissionDate: Date | null,
  dismissalDate: Date | null
): Date | null {
  if (!isValidDate(dismissalDate)) return null;
  return isDismissalDateBeforeAdmission(admissionDate, dismissalDate) ? null : dismissalDate;
}

export function resolveUserDismissalState(
  admissionDate: Date | null,
  dismissalDate: Date | null,
  status: string
): ResolvedUserDismissalState {
  if (isDismissalDateBeforeAdmission(admissionDate, dismissalDate)) {
    return {
      dismissalDate: null,
      status: 'ACTIVE',
    };
  }

  return {
    dismissalDate: getValidDismissalDate(admissionDate, dismissalDate),
    status,
  };
}
